export default __webpack_public_path__ + "static/media/drivability_checker_animation.a3d3fc46.gif";